import React from "react";

export default function LinkIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_656_2904)">
        <path
          d="M12.171 1.14746e-05C11.6681 -0.0012239 11.1698 0.0973044 10.7052 0.289895C10.2405 0.482485 9.81867 0.765313 9.46405 1.12201L6.48305 4.10301C6.71105 4.07101 6.93805 4.03701 7.17105 4.03701C7.80472 4.03714 8.43258 4.15796 9.02105 4.39301L10.878 2.53601C11.2253 2.21509 11.6833 2.04105 12.1561 2.05037C12.6289 2.05969 13.0797 2.25164 13.4141 2.58601C13.7484 2.92037 13.9404 3.37118 13.9497 3.84394C13.959 4.31671 13.785 4.77473 13.464 5.12201L10.122 8.46401C9.43005 9.15401 8.22705 9.15501 7.53605 8.46401L6.12305 9.88001C6.47772 10.2362 6.89948 10.5186 7.36394 10.7109C7.82841 10.9031 8.32637 11.0014 8.82905 11C9.33203 11.0012 9.83027 10.9027 10.2949 10.7101C10.7596 10.5175 11.1814 10.2347 11.536 9.87801L14.878 6.53601C15.2347 6.18138 15.5176 5.75954 15.7102 5.29488C15.9028 4.83023 16.0013 4.332 16 3.82901C15.999 2.81382 15.5952 1.84052 14.8774 1.12267C14.1595 0.404822 13.1862 0.00107034 12.171 1.14746e-05Z"
          fill="white"
        />
        <path
          d="M6.96101 11.625L5.12101 13.465C4.77373 13.7859 4.31571 13.96 3.84294 13.9506C3.37018 13.9413 2.91937 13.7494 2.58501 13.415C2.25064 13.0806 2.05869 12.6298 2.04937 12.1571C2.04005 11.6843 2.21409 11.2263 2.53501 10.879L5.87801 7.53599C6.57001 6.84599 7.77301 6.84499 8.46401 7.53599L9.87701 6.11999C8.43201 4.67599 5.91101 4.67499 4.46401 6.12199L1.12201 9.46399C0.765313 9.81862 0.482485 10.2405 0.289895 10.7051C0.0973044 11.1698 -0.0012239 11.668 1.14746e-05 12.171C0.00107034 13.1862 0.404822 14.1595 1.12267 14.8773C1.84052 15.5952 2.81382 15.9989 3.82901 16C4.332 16.0012 4.83023 15.9027 5.29488 15.7101C5.75954 15.5175 6.18138 15.2347 6.53601 14.878L9.47701 11.937C9.26301 11.965 9.04901 12 8.82901 12C8.17701 12 7.54501 11.87 6.96101 11.625Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_656_2904">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
